// import React, { useEffect, useState } from "react";
// import {
//   SignedIn,
//   SignedOut,
//   SignInButton,
//   UserButton,
//   useUser,
//   useAuth,
// } from "@clerk/clerk-react";
// import { useDispatch } from "react-redux";
// import axiosInstance from "../../axios/axios";

// const Signup = () => {
//   const { user, isSignedIn } = useUser();
//   const { getToken } = useAuth();
//   // const [userData, setUserData] = useState(null);
//   const [token, setToken] = useState(null);
//   const dispatch = useDispatch();
//   useEffect(() => {
//     const fetchTokenAndUserData = async () => {
//       // console.log("Fetching user data...");
//       // console.log("Is Signed In:", isSignedIn);
//       // console.log("User:", user);

//       if (isSignedIn && user) {
//         try {
//           const jwtToken = await getToken();
//           setToken(jwtToken);
//           // console.log("Token:", jwtToken);

//           const userDetails = {
//             email: user.primaryEmailAddress?.emailAddress || "No email",
//             name: {
//               first: user.firstName || "No first name",
//               last: user.lastName || "No last name",
//             },
//             picture: user.imageUrl || "",
//             token: jwtToken,
//           };

//           // console.log("User Details:", userDetails);

//           const response = await axiosInstance.post("register", userDetails);

//           dispatch(loginSuccess(response.data));
//         } catch (error) {
//           console.error("Error fetching token or user data:", error);
//         }
//       } else {
//         console.log("User is not signed in");
//       }
//     };

//     fetchTokenAndUserData();
//   }, [isSignedIn, user, getToken, dispatch]);

//   return (
//     <div>
//       <header>
//         <SignedOut>
//           <SignInButton />
//         </SignedOut>
//         <SignedIn>
//           <UserButton />
//         </SignedIn>
//       </header>
//     </div>
//   );
// };

// export default Signup;
 import React from 'react'
 
 const Googleauth = () => {
   return (
     <div>
       
     </div>
   )
 }
 
 export default Googleauth
 